import React from "react";
import { Offcanvas } from "react-bootstrap";

const PsOffCanvasWindow = (props) => {
  const { show, onHide, title, size = "sm", placement = "end" } = props;

  return (
    <React.Fragment>
      <Offcanvas
        show={show}
        onHide={onHide}
        backdrop="static"
        className={`offcanvas-${size}-${placement}`}
        placement={placement}
      >
        <div style={styles.modalWrapper}>
          <Offcanvas.Header style={styles.header} closeButton>
            <h4>{title}</h4>
          </Offcanvas.Header>

          <div style={styles.bodyWrapper}>
            <Offcanvas.Body style={styles.body}>
              {props.children}
            </Offcanvas.Body>
          </div>
        </div>
      </Offcanvas>
    </React.Fragment>
  );
};

const styles = {
  modalWrapper: {
    border: "3px solid #A9C4B7", // Muted greenish-gray border for a calm look
    padding: "5px",
    backgroundColor: "#EAF0F1", // Light grayish-blue background for the outside
    borderRadius: "10px",
    boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.1)", // Soft shadow for depth
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    backgroundColor: "#4A90E2", // Soft blue header background
    color: "#FFFFFF", // White text for contrast
    borderBottom: "4px solid #357ABD", // Darker blue border for the header
    fontFamily: "'Roboto', sans-serif",
    textAlign: "center",
    textTransform: "uppercase",
    padding: "15px 20px",
    border: "none",
  },
  bodyWrapper: {
    flex: 1,
    overflowY: "auto",
    padding: "0",
  },
  body: {
    backgroundColor: "#F4F9F9", // Soft light gray for the body
    color: "#333333", // Dark text for readability
    fontFamily: "'Open Sans', sans-serif",
    padding: "20px",
    borderTop: "4px solid #357ABD", // Darker blue border at the top
    borderRadius: "5px",
  },
};

export default PsOffCanvasWindow;
